import { IBEError } from '@common/interfaces/be-error.interface';
import {
    IAddress,
    IPostcode,
    IValideDeliveryAddress,
    IValidePostcodeResponse,
    packHouseApiRequest,
    TPackhouseV1ValidateDeliveryAddressPostError,
    TPackhouseV1ValidatePostCodePostError,
} from '@src/api/pack-house-generated-api';
import { useMutation, UseMutationResult } from 'react-query';

const NAME = 'pack-house';
const useValidateDeliveryAddress = (): UseMutationResult<
    IValideDeliveryAddress,
    IBEError<TPackhouseV1ValidateDeliveryAddressPostError>,
    IAddress
> => {
    return useMutation(
        (props) => {
            return packHouseApiRequest.packhouseV1ValidateDeliveryAddressPost(props).then((r) => r.data);
        },
        {
            mutationKey: `${NAME}-validate-delivery-address`,
        },
    );
};

const useValidatePostCode = (): UseMutationResult<
    IValidePostcodeResponse,
    IBEError<TPackhouseV1ValidatePostCodePostError>,
    IPostcode
> => {
    return useMutation(
        (props) => {
            return packHouseApiRequest.packhouseV1ValidatePostCodePost(props).then((r) => r.data);
        },
        {
            mutationKey: `${NAME}-validate-post-code`,
        },
    );
};

export const packHouseInternal = {
    useValidatePostCode,
    useValidateDeliveryAddress,
};
